export default __webpack_public_path__ + "static/media/arrow_dropdown_up_white.753079d8.svg";